import React from 'react';
import how1 from './Assets/howitworks1.png';
import how2 from './Assets/howitworks2.png';
import how3 from './Assets/howitworks3.png';
import how4 from './Assets/howitworks4.png';

import './HowItWorks.css';

const HowItWorks = () => {
    return (
        <section id="howitworks" className="howitworks">
            <h2 className="howitworks_title">How It Works</h2>

            <div className="howitworks_steps">
                <div className="howitworks_step">
                    <div className="howitworks_icon">
                        <img
                            src={how1}
                            alt="User Registration"
                            className="howitworks_image"

                        />
                    </div>
                    <h3 className="howitworks_name">User Registration</h3>
                    <p className="howitworks_description">
                        Sign up and create your account to start managing your smart home.
                    </p>
                </div>

                <div className="howitworks_step">
                    <div className="howitworks_icon">
                        <img
                            src={how2}
                            alt="Setup Your Building"
                            className="howitworks_image"
                        />
                    </div>
                    <h3 className="howitworks_name">Setup Your Building</h3>
                    <p className="howitworks_description">
                        Add your home or office layout and define rooms and zones.
                    </p>
                </div>

                <div className="howitworks_step">
                    <div className="howitworks_icon">
                        <img
                            src={how3}
                            alt="Setup Device Components"
                            className="howitworks_image"
                        />
                    </div>
                    <h3 className="howitworks_name">Setup Device Components</h3>
                    <p className="howitworks_description">
                        Connect and configure smart devices like lights, thermostats, and sensors.
                    </p>
                </div>

                <div className="howitworks_step">
                    <div className="howitworks_icon">
                        <img
                            src={how4}
                            alt="Ready to Start"
                            className="howitworks_image"
                        />
                    </div>
                    <h3 className="howitworks_name">You're Ready to Start</h3>
                    <p className="howitworks_description">
                        Control, automate, and monitor all your smart devices effortlessly.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;